import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import cleanDate from '../tools/cleanDate';

export default function DateInput({
  selectedDay,
  setSelectedDay,
  numDays,
  today,
}) {
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + numDays - 1);

  return (
    <DatePicker
      value={cleanDate(selectedDay)}
      onChange={e => setSelectedDay(e.toDate())}
      inputClass=" w-full px-3 py-3 rounded-lg focus:outline-0 focus:border-primary transition-all duration-150 bg-secondary text-center text-2xl "
      className="purple"
      minDate={cleanDate(today)}
      maxDate={cleanDate(maxDate)}
      containerClassName="w-full"
      calendar={persian}
      locale={persian_fa}
      calendarPosition="top"
    />
  );
}
